<template>
    <div class="empty-box">
        <img src="@/assets/image/default.png" />
        <span>
            <slot>
                {{$t('nullList.ZWSJ')}}
            </slot>
        </span>
        
    </div>
</template>
<script>
export default {
    name: 'nullList'
}
</script>
<style scoped lang="scss">
.empty-box{
    @include wh(100%,100%); min-height: 350px;
    @include flex(); @include alitem(center,center,column);
    img{
        @include wh(150px,150px);
    }
    span{
        @include margin(20px auto);
    }
}
</style>